import React from 'react'
import Select from 'react-select'
import QRCodeReact from 'qrcode.react'
import { ImagePicker } from './resourcepicker'
import { TargetPicker } from './targetPicker'
import { TextareaWithCounter } from './textareaWithCounter'
import { ResizeModePicker } from './resizeModePicker'

const options = [
  { value: 'none', label: 'Pas de validation' },
  { value: 'code', label: 'Mot code' },
  { value: 'qrcode', label: 'QR Code' },
  { value: 'image', label: 'Image en RA' }
]

// Aligné sur la limite des instructions de module, pour un affichage tenant dans l'écran de validation.
const INSTRUCTION_MAX_LENGTH = 200

const typeOptions = [
  { value: 'text', label: 'Texte' },
  { value: 'number', label: 'Nombre' }
]

// Images plein écran, au format portrait.
const fullScreenImageUiSchema = { 'ui:options': { maxSize: { aspect: 0.5625, width: 1080, height: 1920 } } }

export const PointValidation = ({ formData, name, onChange, schema, formContext }) => {
  return (
    <div>
      <div className="form-group field">
        <label className="control-label" htmlFor={name}>
          {schema.title}
        </label>
        <Select
          value={options.find(option => option.value === formData.type) || options[0]}
          onChange={option => onChange({ ...formData, type: option.value })}
          options={options}
          placeholder={'Sélectionnez une méthode de validation'}
          menuPlacement="bottom"
        />
      </div>
      {formData.type === 'code' && (
        <div className="form-group field field-string inline">
          <label htmlFor="textInput" className="control-label">
            Type de code
          </label>
          <Select
            value={typeOptions.find(option => option.value === formData.inputType) || typeOptions[0]}
            onChange={option => onChange({ ...formData, inputType: option.value })}
            options={typeOptions}
            menuPlacement="bottom"
          />
        </div>
      )}
      {['code', 'qrcode'].includes(formData.type) && (
        <>
          <div className="form-group field field-string inline">
            <label htmlFor="textInput" className="control-label">
              Code de validation
            </label>
            <input
              className="form-control"
              type={formData.inputType === 'number' ? 'number' : 'text'}
              id="textInput"
              value={formData.code || ''}
              onChange={event => onChange({ ...formData, code: event.target.value })}
            />
          </div>
          {formData.type === 'qrcode' && formData.code && (
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'end' }}>
              <QRCodeReact value={formData.code} size={128} level="M" />
            </div>
          )}
        </>
      )}

      {formData.type === 'image' && (
        <TargetPicker
          formData={formData.target}
          formContext={formContext}
          onChange={target => onChange({ ...formData, target })}
        />
      )}

      {['code', 'qrcode', 'image'].includes(formData.type) && (
        <div className="form-group field">
          <label className="control-label">Habillage de l'écran de validation</label>
          <p className="field-description">
            {formData.type === 'code'
              ? "Facultatif : sans image ici, celle du thème s'applique, sinon le fond par défaut de l'application."
              : "Facultatif : chaque image absente ici est reprise du thème. Dès qu'une image est définie (ici ou dans le thème), le cadre et le scanner d'origine disparaissent."}
          </p>
          {formData.type === 'code' ? (
            <ImagePicker
              schema={{ title: 'Image de fond' }}
              uiSchema={fullScreenImageUiSchema}
              formData={formData.backgroundImage}
              formContext={formContext}
              onChange={backgroundImage => onChange({ ...formData, backgroundImage })}
            />
          ) : (
            <>
              <ImagePicker
                schema={{ title: 'Image posée sur la caméra pendant le scan' }}
                uiSchema={fullScreenImageUiSchema}
                formData={formData.overlayImage}
                formContext={formContext}
                onChange={overlayImage => onChange({ ...formData, overlayImage })}
              />
              <ImagePicker
                schema={{ title: 'Image transparente affichée quand le scan est validé' }}
                uiSchema={fullScreenImageUiSchema}
                formData={formData.successImage}
                formContext={formContext}
                onChange={successImage => onChange({ ...formData, successImage })}
              />
            </>
          )}
          <ResizeModePicker
            schema={{ title: 'Affichage des images' }}
            uiSchema={{ 'ui:options': { defaultLabel: 'Comme le thème (par défaut : recouvre toute la zone)' } }}
            formData={formData.resizeMode}
            onChange={resizeMode => onChange({ ...formData, resizeMode })}
          />
        </div>
      )}

      {formData.type && formData.type !== 'none' && (
        <div className="form-group field field-string">
          <TextareaWithCounter
            schema={{ title: 'Instructions', maxLength: INSTRUCTION_MAX_LENGTH }}
            uiSchema={{ 'ui:options': { rows: 3 } }}
            formData={formData.instruction || ''}
            onChange={instruction => onChange({ ...formData, instruction })}
          />
        </div>
      )}
    </div>
  )
}
